import React from 'react';
import { STATUS_STEPS, getStatusStepIndex } from '@/services/api/artisan-orders';

interface OrderStatusProgressProps {
  status: string;
  compact?: boolean;
  withInstallation?: boolean;
}

const OrderStatusProgress: React.FC<OrderStatusProgressProps> = ({ status, compact = false, withInstallation = false }) => {
  const isCancelled = status === 'cancelled';
  const currentIdx = isCancelled ? -1 : getStatusStepIndex(status);

  // 取付ありの場合、ラベルを差し替え
  const steps = STATUS_STEPS.map(step => {
    if (!withInstallation) return step;
    if (step.key === 'shipped') return { ...step, label: '取付待' };
    if (step.key === 'reviewed') return { ...step, label: '取付・評価' };
    return step;
  });

  if (isCancelled) {
    return (
      <div className={`flex items-center justify-center ${compact ? 'py-2' : 'py-3'}`}>
        <span className="bg-red-900/50 text-red-400 border border-red-700 px-4 py-1.5 rounded-full text-sm font-medium">
          キャンセル
        </span>
      </div>
    );
  }

  return (
    <div className={`w-full ${compact ? 'py-2' : 'py-3'}`}>
      <div className="flex items-center justify-between relative">
        {/* 接続ライン（背景） */}
        <div className="absolute top-4 left-0 right-0 h-0.5 bg-gray-700 mx-6" />
        {/* 接続ライン（アクティブ） */}
        <div
          className="absolute top-4 left-0 h-0.5 bg-orange-500 mx-6 transition-all duration-500"
          style={{
            width: currentIdx > 0
              ? `calc(${(currentIdx / (steps.length - 1)) * 100}% - 48px)`
              : '0%',
          }}
        />

        {steps.map((step, idx) => {
          const isCompleted = idx < currentIdx;
          const isCurrent = idx === currentIdx;

          return (
            <div key={step.key} className="flex flex-col items-center relative z-10 flex-1">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-all duration-300 ${
                  isCompleted
                    ? 'bg-orange-500 text-white'
                    : isCurrent
                      ? 'bg-orange-500 text-white ring-4 ring-orange-500/30'
                      : 'bg-gray-700 text-gray-500'
                }`}
              >
                {isCompleted ? '✓' : idx + 1}
              </div>
              <span
                className={`mt-1.5 text-center leading-tight ${compact ? 'text-[10px]' : 'text-xs'} ${
                  isCompleted
                    ? 'text-orange-400 font-medium'
                    : isCurrent
                      ? 'text-white font-bold'
                      : 'text-gray-500'
                }`}
              >
                {step.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderStatusProgress;
